import React from 'react';
import {Form} from 'formik';
import classnames from 'classnames';
import FormTitle from "../FormTitle";
import FieldInput from 'common/components/FieldInput';
import FieldTextareaAutosize from "common/components/FieldTextareaAutosize";
import FieldDatepicker from "common/components/FieldDatepicker";
import ButtonsSubmitCancel from "../ButtonsSubmitCancel";
import ButtonTextSuggestions from "../../../../common/components/ButtonTextSuggestions";
import MultipleTooltip from "../../../../common/components/MultipleTooltip";
import MarkFileUploaded from "../../../../common/components/MarkFileUploaded";
import FieldPasteFile from "../../../../common/components/FieldPasteFile";
import FieldPasteImage from "../../../../common/components/FieldPasteImage";
import FieldCheckbox from "../../../../common/components/FieldCheckbox";
import ListUploadedFilesViewDelete from "../ListUploadedFilesViewDelete";
import UploadingFilePopUp from "../../../../common/components/UploadingFilePopUp/UploadingFilePopUp";
import {
  getPropertyLocation,
  propertyProperties,
  planningBackground,
  possessoryBackground,
  areaPropertiesPrices,
  getAdditionalStatements
} from "../../constants/textSuggestions";
import styles from './styles.module.scss';

const Form_8View = ({
                      shumaID,
                      values,
                      prevPagePath,
                      nextPagePath,
                      setFieldValue,
                      cityName = '',
                      bankName = '',
                      onFileSelected,
                      fileUploaded,
                      fileTypeIds,
                      filesListData,
                      progress,
                      showUploadingFilePopUp,
                    }) => {
  const propertyLocation = getPropertyLocation(cityName);
  const additionalStatements = getAdditionalStatements(bankName);

  return (
    <div className={styles.form_8}>
      <FormTitle title={'עקרונות גורמים ושיקולים'}/>
      <Form>
        <FieldTextareaAutosize
          fieldId="propertyLocation"
          value={values.propertyLocation}
          label={
            <div>
              <span>מיקום הנכס</span>
              <ButtonTextSuggestions
                fieldName={'propertyLocation'}
                currentFieldValue={values.propertyLocation}
                textSuggestionsArray={propertyLocation}
                setFieldValue={setFieldValue}
                menuPosition={'down'}
              />
            </div>
          }
          containerCustomStyles={styles.marginBottom25}
        />
        <FieldTextareaAutosize
          fieldId="propertyProperties"
          value={values.propertyProperties}
          label={
            <div>
              <span>מאפיני הנכס כמפורט לעיל</span>
              <ButtonTextSuggestions
                fieldName={'propertyProperties'}
                currentFieldValue={values.propertyProperties}
                textSuggestionsArray={propertyProperties}
                setFieldValue={setFieldValue}
              />
            </div>
          }
          containerCustomStyles={styles.marginBottom25}
        />
        <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
          <FieldDatepicker
            fieldId="officialDate"
            label='המועד הקובע לחוו"ד'
            disabled
            containerStyles={styles.halfRow}
          />
          <FieldInput
            fieldId="houseRegisteredArea"
            value={values.houseRegisteredArea}
            label="שטח ברישוי"
            disabled
            containerCustomStyles={styles.halfRow}
          />
        </div>
        <FieldTextareaAutosize
          fieldId="planningBackground"
          value={values.planningBackground}
          label={
            <div>
              <span>רקע תכנוני</span>
              <ButtonTextSuggestions
                fieldName={'planningBackground'}
                currentFieldValue={values.planningBackground}
                textSuggestionsArray={planningBackground}
                setFieldValue={setFieldValue}
              />
            </div>
          }
          containerCustomStyles={styles.marginBottom25}
        />
        <FieldTextareaAutosize
          fieldId="possessoryBackground"
          value={values.possessoryBackground}
          label={
            <div>
              <span>רקע קנייני</span>
              <ButtonTextSuggestions
                fieldName={'possessoryBackground'}
                currentFieldValue={values.possessoryBackground}
                textSuggestionsArray={possessoryBackground}
                setFieldValue={setFieldValue}
              />
            </div>
          }
          containerCustomStyles={styles.marginBottom25}
        />
        <FieldTextareaAutosize
          fieldId="areaPropertiesPrices"
          value={values.areaPropertiesPrices}
          label={
            <div>
              <span>מחירי נכסים בסביבה בביצוע ההתאמה הנדרשת</span>
              <ButtonTextSuggestions
                fieldName={'areaPropertiesPrices'}
                currentFieldValue={values.areaPropertiesPrices}
                textSuggestionsArray={areaPropertiesPrices}
                setFieldValue={setFieldValue}
              />
            </div>
          }
          containerCustomStyles={styles.marginBottom25}
        />
        <FieldTextareaAutosize
          fieldId="other"
          value={values.other}
          label="אחר"
          containerCustomStyles={styles.marginBottom25}
        />
        <FieldTextareaAutosize
          fieldId="additionalStatements"
          value={values.additionalStatements}
          label={
            <div className={styles.labelWrapper}>
              <span>הצהרות נוספות</span>
              <MultipleTooltip
                id={'additionalStatementsTooltip'}
                customIconClassName={styles.tooltip}
                label={'ניתן להוסיף תבליט באמצעות הוספת הסימן: (*)'}
              />
              <ButtonTextSuggestions
                fieldName={'additionalStatements'}
                currentFieldValue={values.additionalStatements}
                textSuggestionsArray={additionalStatements}
                setFieldValue={setFieldValue}
              />
            </div>
          }
          containerCustomStyles={styles.marginBottom25}
        />
        <FieldTextareaAutosize
          fieldId="notes"
          value={values.notes}
          label="הערות"
          containerCustomStyles={styles.marginBottom25}
        />
        <h4 className={classnames(styles.subHeader, styles.marginBottomLow)}>הערות</h4>
        <FieldCheckbox fieldId={'fileType36Switch'}/>
        <div className={classnames(styles.uploadFilesUnit, styles.marginBottom25)}>
          {fileUploaded.propertyDrawingFileUploaded && <MarkFileUploaded/>}
          {!values.fileType36Switch
            ? (
              <FieldPasteFile
                fieldId="notesFileUploaded"
                fileUploaded={fileUploaded.notesFileUploaded}
                onFileSelected={onFileSelected(fileTypeIds.notes)}
                setFieldValue={setFieldValue}
              />
            )
            : (
              <FieldPasteImage
                fieldId="notesFileUploaded"
                fileUploaded={fileUploaded.notesFileUploaded}
                onFileSelected={onFileSelected(fileTypeIds.notes)}
                setFieldValue={setFieldValue}
                formFields={'onlyFreeText'}
              />
            )
          }
        </div>
        <ListUploadedFilesViewDelete
          data={filesListData}
          fileTypeID={fileTypeIds.notes}
          shumaId={shumaID}
        />
        <div className={styles.marginBottom64}/>
        <ButtonsSubmitCancel
          prevPagePath={prevPagePath}
          nextPagePath={nextPagePath}
        />
      </Form>
      <UploadingFilePopUp
        showUploadingFilePopUp={showUploadingFilePopUp}
        progress={progress}
        message="הקובץ נטען, אנא המתינו"
      />
    </div>
  )
};

export default Form_8View;